import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setSelectedAmountOfLoansInput } from '../../../../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice';
import MinMaxPortfolioAmount from './min-max-portfolio-amount';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

export default function InputsAmountOfLoans() {

    const dispatch = useDispatch();
    const { amountOfLoans, } = useProposalTypeData()

    useEffect(() => {
        if (!amountOfLoans) return;

        dispatch(
            setSelectedAmountOfLoansInput({
                label: amountOfLoans.name,
                value: "",
            })
        );
    }, [amountOfLoans, dispatch]);
    
    // const fAmount = formatNumberWithComma(amountOfLoansFAmount ?? '');
    // const handleChange = (value: string) => {
    //     if (!amountOfLoans) return;

    //     const numericValue = parseFloat(value.replace(/,/g, ""));

    //     dispatch(setFAmountOfLoans(isNaN(numericValue) ? null : numericValue));
    //     dispatch(resetSelectedRiders())
    //     dispatch(resetLoanAmountRiders())
    // };
    
    return (
        <div className="w-full">
            <MinMaxPortfolioAmount/>
        </div>
    )
}
